import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { FaBars, FaTimes, FaArrowLeft } from 'react-icons/fa';
import CustomerSidebar from '../components/CustomerSidebar';
import talentLogo3 from '../../assets/talentlogo3-removebg-preview.png';

const CustomerLayout = ({ children }) => {
  const navigate = useNavigate();
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background flex flex-col md:flex-row">
      {/* Mobile Header */}
      <div className="md:hidden bg-sidebar-bg text-sidebar-text px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate(-1)} className="p-1 hover:bg-sidebar-hover rounded">
            <FaArrowLeft className="w-4 h-4" />
          </button>
          <button onClick={() => setIsMobileSidebarOpen(true)} className="p-1 hover:bg-sidebar-hover rounded">
            <FaBars className="w-4 h-4" />
          </button>
          <h1 className="text-lg font-semibold">Customer</h1>
        </div>
        <img src={talentLogo3} alt="Talent Logo" className="h-8 w-auto" />
      </div>

      {/* Mobile Sidebar Overlay */}
      <div 
        className={`fixed inset-0 z-50 md:hidden transition-opacity duration-300 ${
          isMobileSidebarOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => setIsMobileSidebarOpen(false)}></div>
        <div 
          className={`absolute left-0 top-0 h-full w-72 sm:w-80 bg-sidebar-bg text-sidebar-text flex flex-col transform transition-transform duration-300 ease-in-out ${
            isMobileSidebarOpen ? 'translate-x-0' : '-translate-x-full'
          }`}
        >
          <div className="p-4 flex items-center justify-between border-b border-sidebar-hover">
            <img src={talentLogo3} alt="Talent Logo" className="h-10 w-auto" />
            <button onClick={() => setIsMobileSidebarOpen(false)} className="p-1 hover:bg-sidebar-hover rounded transition-colors duration-200">
              <FaTimes className="w-5 h-5" />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto">
            <CustomerSidebar onLinkClick={() => setIsMobileSidebarOpen(false)} />
          </div>
        </div>
      </div>

      {/* Desktop Sidebar */}
      <div className="hidden md:flex w-[12rem] flex-shrink-0">
        <CustomerSidebar />
      </div>

      <div className="flex-1 flex flex-col min-w-0 min-h-0 overflow-hidden">
        {children}
      </div>
    </div>
  );
};

export default CustomerLayout;